<template>
  <div ref="pdfRoot" justify="center">
    <div class="pdf-preview">
      <vue-pdf-embed
      :source="{url: pdfFileUrl, cMapUrl: '/cmaps/', cMapPacked: true}"
      annotation-layer
      text-layer
      />
    </div>
    <v-container style="max-width: 800px">
      <v-row justify="center" style="text-align: center">
        <v-col cols="6">
          <v-btn
            color="secondary"
            outlined
            class="ma-2"
            width="200"
            @click="cancel"
            >戻る</v-btn
          >
        </v-col>
        <v-col cols="6">
          <v-btn
            color="secondary"
            outlined
            class="ma-2"
            width="200"
            @click="savePdf"
            >保存</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
import Api from "@/logic/api/api.js";
import AlertBuilder from "../../logic/common/alert-contents";
import valueMapper from "../../logic/common/value-mapper";

export default {
  components: {
    VuePdfEmbed,
  },
  computed: {
  },
  data() {
    // URLから参照先を取得する
    const uid = this.$route.params.uid;
    console.log("uid = " + uid);
    this.$nextTick(() => {
      this.loadData(uid);
    });
    return {
      pdfFileUrl: "",
      pdfFileName: "",
    };
  },
  mounted() {
    this.$refs.pdfRoot?.addEventListener("click", this._onPdfLinkClick, true);
  },
  beforeDestroy() {
    this.$refs.pdfRoot?.removeEventListener("click", this._onPdfLinkClick, true);
  },  
  methods: {
    /**
     * PDF内のリンクをクリックしたときに別タブで表示する
     */
    _onPdfLinkClick(e) {
      const a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      let href = a.getAttribute('href');
      if (!href) return;
      e.preventDefault();
      window.open(href, "_blank", "noopener,noreferrer");
    },
    /**
     * PDFを取得、画面に表示する
     */
    loadData(uid) {
      console.log("loadData(uid) = " + uid);
      this.$store.commit("setWaiting", true);
      this.$nextTick(() => {
        const mapping = [];
        const process = [];

        // お知らせを取得する
          mapping.push("information.list");
          process.push(
            Api.call("/admin/information", {})
          );
/*         } */
        // 必要なAPIを全て実行する
        Promise.all(process)
          .then((result) => {
            this.$store.commit("setWaiting", false);
            var informationList = result[mapping.indexOf("information.list")].informations;
            var found = informationList.find(e => e.record_id == uid);
            console.log("found.pdfFileUrl = " + found.file_url);
            this.pdfFileUrl = found.file_url
            this.pdfFileName = found.file_name;
          })
          .catch((result) => {
            // エラーになったリクエストが一つでもあればここに入る
            this.$store.commit("setWaiting", false);
            const message = valueMapper
              .map({
                403: AlertBuilder.error("権限がありません"),
              })
              .getOrElse(result.status, AlertBuilder.invalid());
            if (message.isInvalid) {
              Api.resolve(result);
            } else {
              this.showMessage(message);
            }
          });
      });
    },
    /**
     * メッセージを初期化する
     */
    clearMessage() {
      this.errors = [];
    },
    /**
     * メッセージを表示する
     */
    showMessage(error) {
      this.errors.push(error);
      window.scrollTo(0, 0);
    },
    cancel() {
      this.$router.go(-1); // 1つ前のページに戻る
    },
    async savePdf() {
      const response = await fetch(this.pdfFileUrl);
      const blob = await response.blob();
      const newBlob = new Blob([blob]);
      const objUrl = window.URL.createObjectURL(newBlob);
      const link = document.createElement("a");
      link.href = objUrl;
      link.download = this.pdfFileName;
      link.click();
      // For Firefox it is necessary to delay revoking the ObjectURL.
      setTimeout(() => {
        window.URL.revokeObjectURL(objUrl);
      }, 250);
    }
/*     savePdf() {
      const url = this.pdfFileUrl;
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.download = this.pdfFileName;
      a.href = url;
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } */
  },
};
</script>

<style scoped>
.pdf-preview {
  padding: 16px;
  background-color: #ccc;
}
</style>

<style>
.vue-pdf-embed > div {
  margin-bottom: 8px;
  box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
}
</style>
